// extracted by mini-css-extract-plugin
export default {"container":"ToolResponse__container___yA7sa"};